// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const APP_URL = 'https://dev.desk.buyerforesight.net';
const API_URL = 'https://dev.api.desk.buyerforesight.net';

export const environment = {
  production: false,
  app_url: APP_URL,
  api_url: API_URL,
  google_login_provider: "254591168563-kipk5fpv3b1pego7r4iavh6kuintho2r.apps.googleusercontent.com" 
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
